export const pricing = [
  {
    id: "1",
    name: "Старт",
    price: "от 5 000 ₽",
    period: "за услугу",
    description: "Базовый подбор администратора для небольших объектов",
    popular: false,
    features: [
      "Подбор кандидатов по вашим критериям",
      "Первичное собеседование и проверка рекомендаций",
      "Базовое обучение стандартам ресепшн",
      "Подготовка к выходу на смену",
      "Поддержка в течение 14 дней",
    ],
    notIncluded: [
      "CRM-система",
      "Внедрение СМК",
      "Цифровизация процессов",
    ],
  },
  {
    id: "2",
    name: "Профессионал",
    price: "от 80 000 ₽",
    period: "в месяц",
    description: "Полный комплект: подбор, обучение и внедрение CRM",
    popular: true,
    features: [
      "Всё из тарифа Старт",
      "Расширенное обучение (3 недели)",
      "Внедрение CRM для учёта клиентов",
      "Обучение персонала работе с CRM",
      "Настройка базовых отчётов",
      "Поддержка в течение 3 месяцев",
      "Гарантия замены сотрудника",
    ],
    notIncluded: [
      "Внедрение СМК",
      "Цифровизация всех процессов",
    ],
  },
  {
    id: "3",
    name: "Премиум",
    price: "Обсудить",
    period: "индивидуально",
    description: "Комплексное преобразование всей административной системы",
    popular: false,
    features: [
      "Всё из тарифа Профессионал",
      "Полная цифровизация процессов",
      "Разработка и внедрение СМК",
      "Обучение всего персонала работе с новыми системами",
      "Интеграция CRM с сайтом бронирования",
      "Ежемесячный аудит и оптимизация",
      "Личный менеджер проекта",
      "Приоритетная поддержка 24/7",
    ],
    notIncluded: [],
  },
];